import { createReducer, on, Action } from '@ngrx/store';

import * as CommonActions from './common.actions';

export const COMMON_FEATURE_KEY = 'common';

export interface State {
  brand: string;
}

export interface CommonPartialState {
  readonly [COMMON_FEATURE_KEY]: State;
}

export const initialState: State = {
  brand: 'notset'
};

const commonReducer = createReducer(
  initialState,
  on(CommonActions.loadBrand, state => ({ ...state })),
  on(CommonActions.loadBrandSuccess, (state, { brand }) => ({
    ...state,
    brand
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return commonReducer(state, action);
}
